import React from 'react';
import styled from '@emotion/styled';
import Results, { ResultItem } from '../Symbols/Results';

const formatCurrency = amount => {
	return Math.round(amount).toLocaleString('cs') + ' Kč';
};

const Div = styled('div')`
	font-weight: bold;
	font-size: 18px;
	line-height: 26px;
	padding: 5px 10px;
`;

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

export default function StyledResult({ rodicovska }) {
	return (
		<Results data-cy="result">
			<ResultItem name="Maximální výše rodičovského příspěvku:">
				<ResultNumber>{formatCurrency(rodicovska.maxSubsidy)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Minimální délka rodičovské:">
				<ResultNumber>{rodicovska.minLength} měsíců</ResultNumber>
			</ResultItem>
			<Div data-cy="result-info">
				Částku {formatCurrency(rodicovska.desiredSubsidy)} byste mohli dostávat po dobu{' '}
				{rodicovska.calculatedLength} měsíců.
			</Div>
			<Div data-cy="result-info">
				Pokud byste chtěli dostávat rodičovský příspěvek po dobu {rodicovska.desiredLength} měsíců,
				pak bude výše příspěvku {formatCurrency(rodicovska.calculatedSubsidy)}.
			</Div>
		</Results>
	);
}
